import { UtilitySyncEdit } from './utility-sync-edit.page';

export { UtilitySyncEdit };
